// @ts-ignore
const coworkerOptionsParser = ({ results }) =>
  // @ts-ignore
  results.map(({ profile, id }) => {
    if (!profile) return {};
    return { key: id, fullName: `${profile?.first_name} ${profile?.last_name}` };
  });
export default coworkerOptionsParser;
